"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidDataRollupService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const rollup_1 = require("./rollup");
let BidDataRollupService = class BidDataRollupService {
    constructor(_http, _talk) {
        this._http = _http;
        this._talk = _talk;
        this.intervalFormats = {
            hourly: "MMMM Do YYYY, h:00 a",
            daily: "MMMM Do YYYY",
            monthly: "MMMM YYYY",
        };
        //initializations
        this.rollupURL = "/rollup";
    }
    pull(dataSourceConnection) {
        let params = "";
        if (dataSourceConnection)
            params += `dataSourceConnection=${dataSourceConnection}`;
        return this._http
            .get(`${this.rollupURL}?${params}`)
            .toPromise()
            .then(response => response.json())
            .catch(this._talk.handle);
    }
    getSourceConnectionRollup(rollupTimes, dataSourceConnection) {
        return (rollupTimes.find(rollupTime => rollupTime.dataSourceConnection === dataSourceConnection) || new rollup_1.Rollup());
    }
    getRolllupIntervalDate() {
        return __awaiter(this, arguments, void 0, function* (interval = "hourly", userTzHour, dataSourceConnection) {
            const rollupTimes = yield this.pull(dataSourceConnection);
            const sourceConnectionTimes = this.getSourceConnectionRollup(rollupTimes, dataSourceConnection);
            const intervalTime = sourceConnectionTimes[interval] || sourceConnectionTimes.hourly;
            return this.formatRollupDate({ interval, userTzHour, intervalTime });
        });
    }
    formatRollupDate({ interval, userTzHour, intervalTime }) {
        // Need to call .utc() even though the time stored on the Rollup table is in
        // UTC format, because the browser will use the OS's timezone.
        const dateStr = moment(intervalTime)
            .utc()
            .add(userTzHour, "hours")
            .format(this.getIntervalFormat(interval));
        return this.appendUtcText(dateStr, userTzHour);
    }
    getIntervalFormat(interval) {
        return this.intervalFormats[interval] || this.intervalFormats.hourly;
    }
    appendUtcText(timeStr, userTzHour) {
        return userTzHour !== 0
            ? `${timeStr} (UTC ${userTzHour})`
            : `${timeStr} (UTC)`;
    }
};
exports.BidDataRollupService = BidDataRollupService;
exports.BidDataRollupService = BidDataRollupService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService])
], BidDataRollupService);
//# sourceMappingURL=bid-data-rollup.service.js.map